import { render } from "./PatientCharts.vue?vue&type=template&id=5aa3300d&ts=true"
import script from "./PatientCharts.ts?vue&type=script&lang=ts&external"
export * from "./PatientCharts.ts?vue&type=script&lang=ts&external"

import "./PatientCharts.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__